module.exports = __webpack_public_path__ + "media/bootstrap-icons/flag-fill-b3caf1bc.svg";